'use client';

import { useState } from 'react';
import { subscribeNewsletter } from '@/lib/kit-client';

export function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [state, setState] = useState<'idle' | 'sending' | 'done' | 'error'>('idle');

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (state === 'sending') return;
    setState('sending');
    try {
      await subscribeNewsletter(email);
      setState('done');
      setEmail('');
    } catch {
      setState('error');
    }
  }

  if (state === 'done') {
    return (
      <p className="mt-5 flex items-center gap-2 text-sm text-spark-300" role="status">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M20 6 9 17l-5-5" />
        </svg>
        You&apos;re on the list.
      </p>
    );
  }

  return (
    <form method="post" onSubmit={onSubmit} className="mt-5">
      <label htmlFor="newsletter-email" className="sr-only">
        Email address
      </label>
      <div className="flex gap-2">
        <input
          id="newsletter-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@company.com"
          autoComplete="email"
          className="min-w-0 flex-1 rounded-full border border-line-2 bg-veil-2 px-4 py-2.5 text-sm text-mist-100 placeholder:text-mist-500 transition-colors focus:border-spark-500/60 focus:outline-none"
        />
        <button
          type="submit"
          disabled={state === 'sending'}
          className="btn btn-ghost px-4 py-2.5 text-sm disabled:opacity-60"
        >
          {state === 'sending' ? 'Joining…' : 'Join'}
        </button>
      </div>
      {state === 'error' && (
        <p className="mt-2 text-xs text-danger" role="alert">
          That didn&apos;t go through. Email sales@kitagency.co and we&apos;ll add you manually.
        </p>
      )}
    </form>
  );
}
